import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BecomeVisibleDirective } from './become-visible.directive';
import { BecomeVisibleElementsDirective } from './become-visible-elements.directive';
import { BecomeVisibleElementDirective } from './become-visible-element.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [BecomeVisibleDirective, BecomeVisibleElementsDirective, BecomeVisibleElementDirective],
    exports: [BecomeVisibleDirective, BecomeVisibleElementsDirective, BecomeVisibleElementDirective],
})
export class BecomeVisibleModule {}
